import './Footer.css';

function Footer() {
  return (
    <footer className="footer">

      <p>
        This site uses Google Analytics to understand how visitors engage with our content.
        No personal data is collected, and all information is anonymized. We use this data
        solely to improve your experience.
      </p>

      <p>
        Disclosure: The Finding Spot uses affiliate links (including platforms like Expedia
        and Booking.com), which means I may earn a small commission if you choose to make a
        purchase through them—at no extra cost to you. I’m not recommending any specific
        product or service. I’m simply sharing my personal experiences and opinions, along
        with publicly available information. I strive to keep all content accurate and up to
        date, but details may change over time.
      </p>

      <p>
        The Finding Spot is a participant in the Amazon Services LLC Associates Program,
        the eBay Partner Network, the Expedia Affiliate Program, and the Booking.com
        Affiliate Partner Program—affiliate advertising programs designed to provide a
        means for sites to earn advertising fees by linking to Amazon.com, eBay.com,
        Expedia.com, and Booking.com.
      </p>

      <p>© 2025 The Finding Spot. All rights reserved.</p>

    </footer>
  );
}

export default Footer;
